export function Footer({ stats }) {
    return (
        <footer className="mt-24 border-t border-border bg-foreground text-background px-6 md:px-12 py-16" data-testid="footer">
            <div className="grid md:grid-cols-3 gap-12">
                <div>
                    <p className="font-mono-label text-xs opacity-70 mb-4">Colophon</p>
                    <p className="font-display text-3xl leading-tight">
                        A <span className="font-editorial text-primary">field guide</span> to
                        women-focused movement, made in NYC.
                    </p>
                </div>
                <div>
                    <p className="font-mono-label text-xs opacity-70 mb-4">Sources</p>
                    <ul className="text-sm space-y-2 opacity-90">
                        <li>Studio websites</li>
                        <li>Mindbody / ClassPass public listings</li>
                        <li>Google Business profiles</li>
                        <li>Yelp · Eventbrite · Meetup</li>
                        <li>Community wellness calendars</li>
                    </ul>
                </div>
                <div>
                    <p className="font-mono-label text-xs opacity-70 mb-4">Stats</p>
                    <ul className="text-sm space-y-2 opacity-90">
                        <li>{stats?.total_classes ?? "—"} class entries</li>
                        <li>{stats?.total_studios ?? "—"} studios indexed</li>
                        <li>{stats?.total_categories ?? "—"} categories</li>
                        <li>{stats?.manual_review_count ?? "—"} flagged for manual review</li>
                        <li className="opacity-70">Last verified: {stats?.last_verified ?? "—"}</li>
                    </ul>
                </div>
            </div>
            <div className="mt-12 pt-6 border-t border-background/20 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                <p className="font-mono-label text-[10px] opacity-60">
                    © 2026 · Curated from publicly available sources only.
                </p>
                <p className="font-mono-label text-[10px] opacity-60">
                    No scraping behind logins or paywalls.
                </p>
            </div>
        </footer>
    );
}
